import { createContext, ReactNode, ComponentType, useState } from 'react';
import axios from 'axios';
import { Localize, useTransform } from '@hilma/netina2all';

interface ChildrenProps {
    children: ReactNode
}

interface MembersProviderValue {
    members: MembersResponse[] | null;
    getMembers(): Promise<void>;
    showFetchError: boolean;
}

interface MembersResponse {
    id: number;
    imagePath: string;
    memberName: string;
    description: string;
}

export const MembersContext = createContext<MembersProviderValue | null>(null)

export const MembersProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const [members, setMembers] = useState<Localize<MembersResponse>[] | null>(null);
    const translatedMembers = useTransform<MembersResponse>(members);
    const [showFetchError, setShowFetchError] = useState<boolean>(false);

    const getMembers = async () => {
        try {
            if (members) return;
            const res = await axios.get('/api/member/get-members');
            setMembers(res.data);
        } catch (error) {
            setShowFetchError(true)
        }
    }

    return (
        <MembersContext.Provider value={{ members: translatedMembers, getMembers, showFetchError }}>
            {children}
        </MembersContext.Provider>
    )

}
